module.exports = __webpack_public_path__ + "img/success.6c326fa1.svg";